import ImageCaptureError from './ImageCaptureError';

export default ImageCaptureError;
